import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  KeywordsPages,
  MainTitle,
} from '../../utils/Constants';
import {
  AboutPageAdditionalMeta,
  AboutPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';

function AboutPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Step into the world of ${CompanyName}, where indulgence, power, and submission collide. Explore My expertise, desires, and the experiences that await you.`}
        keywords={KeywordsPages}
        additionalMeta={AboutPageAdditionalMeta}
        structuredData={AboutPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Biography of ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl text-colour7 tracking-widest'
            >
              About {CompanyName}
            </h1>
          </header>

          {/* Main page content */}
          <AboutPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default AboutPage;
